import React from "react";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

import { useSelector } from "react-redux";

function UnendorsedToggle({
  includeUnsurfacedVariables,
  handleUnendorsedChange,
}) {
  const showIncludeEndorsedVariablesToggle = useSelector(
    (state) => state.showIncludeEndorsedVariablesToggle
  );

  if (showIncludeEndorsedVariablesToggle) {
    return (
      <Tooltip title="Unendorsed variables are from interim or logistic datasets that are not for general use">
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={includeUnsurfacedVariables}
                onChange={handleUnendorsedChange}
                size="small"
              />
            }
            label="Include Unendorsed Variables"
          />
        </FormGroup>
      </Tooltip>
    );
  } else {
    return null;
  }
}

export default UnendorsedToggle;
